export enum SystemRoles {
  ADMIN = <any>'admin',
  PRO = <any>'verified creator',
  BRAND_MEMBER = <any>'brand team member',
  BRAND_ADMIN = <any>'brand admin',
  BRAND_TEAM_SALES = <any>'brand sales',
  PRO_TEAM_ADMIN = <any>'pro team admin',
  SALES_TEAM = <any>'sales',
  ACCOUNT_MANAGER_ADMIN = <any>'account manager admin',
  POST_PRODUCTION_ADMIN = <any>'post production admin',
  INTERNAL = <any>'internal',
}

// Canonical alias for a SystemRoles KEY string (e.g. "BRAND_ADMIN") — what
// getUserRole() returns and what role-scoped UI compares against. Import this
// instead of re-declaring `keyof typeof SystemRoles` locally.
export type SystemRoleKey = keyof typeof SystemRoles;

// The role keys RouteRoleGuard's role="INTERNAL" expands to — mirrors the
// API's internalControl usertype allowlist. Import instead of re-declaring.
export const INTERNAL_ROLE_KEYS: SystemRoleKey[] = [
  'ADMIN',
  'PRO_TEAM_ADMIN',
  'ACCOUNT_MANAGER_ADMIN',
  'POST_PRODUCTION_ADMIN',
  'SALES_TEAM',
];
